import React from "react"
import { View, TouchableOpacity } from "react-native"
import { Tiny } from "@/components/standard/BFText"

interface AgreeCheckBoxProps {
  text?: string
  checked: boolean
  onPress: () => void
}

const AgreeCheckBox: React.FC<AgreeCheckBoxProps> = ({
  text,
  checked,
  onPress,
}) => {
  return (
    <TouchableOpacity
      testID={"agree-check"}
      onPress={onPress}
      className="flex-row items-center"
    >
      <View
        className={`size-5 border ${checked ? "bg-green-500 border-midnight-blue" : "border-midnight-blue"}`}
      >
        {checked && (
          <View className="size-3 bg-green-500 rounded-full m-auto" />
        )}
      </View>

      {text && <Tiny className="ml-2 mt-1 text-midnight-blue">{text}</Tiny>}
    </TouchableOpacity>
  )
}

export default AgreeCheckBox
